// The champagne spray: a stream of bubbles and foam from the bottom corner,
// arcing across the screen, with gold confetti falling through it.

export function spray(canvas, { reducedMotion = false } = {}) {
  const ctx = canvas.getContext('2d');
  const dpr = Math.min(2, window.devicePixelRatio || 1);
  let w = 0;
  let h = 0;
  const size = () => {
    w = canvas.clientWidth || 360;
    h = canvas.clientHeight || 640;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  size();

  const drops = [];
  const confetti = [];
  const GOLD = ['#f5d36b', '#e8b931', '#fff2c2', '#d0141c', '#ffffff'];
  for (let i = 0; i < (reducedMotion ? 30 : 90); i++) {
    confetti.push({ x: Math.random() * w, y: -Math.random() * h, vy: 40 + Math.random() * 60, r: Math.random() * Math.PI, c: GOLD[i % GOLD.length] });
  }

  if (reducedMotion) {
    for (const c of confetti) c.y = Math.random() * h;
    draw();
    return () => {};
  }

  let raf = 0;
  let last = window.performance.now();
  let t = 0;
  function frame(now) {
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    t += dt;
    // Spray for four seconds, from both bottom corners in turn.
    if (t < 4) {
      for (let i = 0; i < 14; i++) {
        const left = Math.floor(t * 2) % 2 === 0;
        const ang = -Math.PI / 2 + (left ? 0.55 : -0.55) + (Math.random() - 0.5) * 0.35;
        const sp = 520 + Math.random() * 380;
        drops.push({ x: left ? 18 : w - 18, y: h - 30, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, life: 1.6 + Math.random(), r: 1.5 + Math.random() * 3.5 });
      }
    }
    for (const d of drops) {
      d.vy += 520 * dt;
      d.x += d.vx * dt;
      d.y += d.vy * dt;
      d.life -= dt;
    }
    for (let i = drops.length - 1; i >= 0; i--) if (drops[i].life <= 0 || drops[i].y > h + 20) drops.splice(i, 1);
    for (const c of confetti) {
      c.y += c.vy * dt;
      c.r += dt * 3;
      if (c.y > h + 10) { c.y = -10; c.x = Math.random() * w; }
    }
    draw();
    if (t < 12 || drops.length) raf = requestAnimationFrame(frame);
  }

  function draw() {
    ctx.clearRect(0, 0, w, h);
    for (const d of drops) {
      ctx.globalAlpha = Math.max(0, Math.min(1, d.life));
      ctx.fillStyle = d.r > 3.5 ? '#fffbe6' : '#f6e08a';
      ctx.beginPath();
      ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 0.9;
    for (const c of confetti) {
      ctx.save();
      ctx.translate(c.x, c.y);
      ctx.rotate(c.r);
      ctx.fillStyle = c.c;
      ctx.fillRect(-4, -2, 8, 4);
      ctx.restore();
    }
    ctx.globalAlpha = 1;
  }

  raf = requestAnimationFrame(frame);
  return () => cancelAnimationFrame(raf);
}
